import { define } from './define';

// The agent's monthly content plan and the client's promotions. Plain words: the client decides what the month is about.
export const plan = define({
  es: {
    'plan.title': 'Plan del mes',
    'plan.nav': 'Plan',
    'plan.intro': 'Lo que el agente propone publicar este mes y por qué. Coméntalo como un post: cuando lo apruebas, el agente prepara cada borrador a partir de él.',
    'plan.month': 'Mes',
    'plan.none': 'Todavía no hay plan para este mes. El agente lo propone unas semanas antes.',
    'plan.version': 'Versión {n}',
    'plan.byAgent': 'propuesto por el agente',
    'plan.by': 'por {who}',
    'plan.state.in_review': 'Espera tu decisión',
    'plan.state.changes_requested': 'Cambios pedidos',
    'plan.state.approved': 'Aprobado',
    'plan.state.superseded': 'Sustituido',
    'plan.approvedBy': 'Aprobado por {who}, {when}. Los borradores del mes salen de este plan.',
    'plan.approvedStill': 'La versión {n} aprobada sigue contando hasta que apruebes esta.',
    'plan.posts': { one: '{count} publicación', other: '{count} publicaciones' },
    'plan.type.package_spotlight': 'Paquete',
    'plan.type.real_event': 'Evento real',
    'plan.type.venue_feature': 'El lugar',
    'plan.type.planning_tip': 'Consejo',
    'plan.type.seasonal': 'Temporada',
    'plan.type.promotion': 'Promoción',
    'plan.type.faq_answer': 'Pregunta frecuente',
    'plan.type.behind_the_scenes': 'Entre bastidores',
    'plan.type.dish_spotlight': 'Plato',
    'plan.type.catering': 'Catering',
    'plan.type.real_moment': 'Momento real',
    'plan.type.kitchen_story': 'La cocina',
    'plan.type.tip': 'Consejo',
    'plan.type.offer_spotlight': 'Lo que ofrecemos',
    'plan.type.place_feature': 'El lugar',
    'plan.facts': 'Datos que usará',
    'plan.buyer': 'Para: {who}',
    'plan.noFacts': 'Ningún dato concreto',
    'plan.photo': 'Foto',
    'plan.noPhoto': 'Sin foto elegida',
    'plan.promotion': 'Promoción: {title}',
    'plan.comment': 'Comentar',
    'plan.commentItem': 'Comentar esta publicación',
    'plan.commentPlaceholder': 'Qué cambiarías…',
    'plan.commentPlan': 'Comentario sobre todo el plan',
    'plan.send': 'Enviar',
    'plan.questions': 'El agente pregunta',
    'plan.answerHint': 'Responde con un comentario.',
    'plan.openComments': { one: '{count} comentario abierto', other: '{count} comentarios abiertos' },
    'plan.requestChanges': 'Pedir cambios',
    'plan.approve': 'Aprobar el plan',
    'plan.approvedToast': 'Plan aprobado. El agente preparará los borradores.',
    'plan.changesToast': 'Cambios pedidos. El agente responderá con una nueva versión.',
    'plan.resolve': 'Cerrar',
    'plan.resolved': 'resuelto en la versión {n}',
    'plan.closed': 'cerrado',
    'plan.history': 'Versiones anteriores',
    'plan.historyRow': 'Versión {n} · {state} · {when}',
    'plan.home.title': 'Plan del mes',
    'plan.home.ready': 'Plan de {month} listo para revisar',
    'plan.home.cta': 'Revisar el plan',
    'promo.title': 'Lo que quieres impulsar',
    'promo.intro': 'Temporadas, campañas o eventos en los que quieres que el agente ponga el foco. Guían el plan; no son datos: los precios y ofertas que el agente puede decir salen de tu web.',
    'promo.name': 'Qué',
    'promo.details': 'Detalles para el agente',
    'promo.starts': 'Desde',
    'promo.ends': 'Hasta',
    'promo.add': 'Añadir',
    'promo.added': 'Añadido. El agente lo tendrá en cuenta en el próximo plan.',
    'promo.archive': 'Quitar',
    'promo.archived': 'Quitado',
    'promo.none': 'Nada todavía.',
    'promo.range': '{from} – {to}',
  },
  en: {
    'plan.title': 'Monthly plan',
    'plan.nav': 'Plan',
    'plan.intro': 'What the agent proposes to post this month, and why. Comment on it like a post: once you approve it, the agent prepares each draft from it.',
    'plan.month': 'Month',
    'plan.none': 'No plan for this month yet. The agent proposes one a few weeks ahead.',
    'plan.version': 'Version {n}',
    'plan.byAgent': 'proposed by the agent',
    'plan.by': 'by {who}',
    'plan.state.in_review': 'Waiting for your decision',
    'plan.state.changes_requested': 'Changes requested',
    'plan.state.approved': 'Approved',
    'plan.state.superseded': 'Superseded',
    'plan.approvedBy': 'Approved by {who}, {when}. The month’s drafts are made from this plan.',
    'plan.approvedStill': 'Approved version {n} still counts until you approve this one.',
    'plan.posts': { one: '{count} post', other: '{count} posts' },
    'plan.type.package_spotlight': 'Package',
    'plan.type.real_event': 'Real event',
    'plan.type.venue_feature': 'The venue',
    'plan.type.planning_tip': 'Planning tip',
    'plan.type.seasonal': 'Seasonal',
    'plan.type.promotion': 'Promotion',
    'plan.type.faq_answer': 'Common question',
    'plan.type.behind_the_scenes': 'Behind the scenes',
    'plan.type.dish_spotlight': 'Dish',
    'plan.type.catering': 'Catering',
    'plan.type.real_moment': 'Real moment',
    'plan.type.kitchen_story': 'The kitchen',
    'plan.type.tip': 'Tip',
    'plan.type.offer_spotlight': 'What we offer',
    'plan.type.place_feature': 'The place',
    'plan.facts': 'Facts it will use',
    'plan.buyer': 'For: {who}',
    'plan.noFacts': 'No specific fact',
    'plan.photo': 'Photo',
    'plan.noPhoto': 'No photo chosen',
    'plan.promotion': 'Promotion: {title}',
    'plan.comment': 'Comment',
    'plan.commentItem': 'Comment on this post',
    'plan.commentPlaceholder': 'What would you change…',
    'plan.commentPlan': 'Comment on the whole plan',
    'plan.send': 'Send',
    'plan.questions': 'The agent asks',
    'plan.answerHint': 'Answer with a comment.',
    'plan.openComments': { one: '{count} open comment', other: '{count} open comments' },
    'plan.requestChanges': 'Request changes',
    'plan.approve': 'Approve the plan',
    'plan.approvedToast': 'Plan approved. The agent will prepare the drafts.',
    'plan.changesToast': 'Changes requested. The agent will answer with a new version.',
    'plan.resolve': 'Close',
    'plan.resolved': 'resolved in version {n}',
    'plan.closed': 'closed',
    'plan.history': 'Earlier versions',
    'plan.historyRow': 'Version {n} · {state} · {when}',
    'plan.home.title': 'Monthly plan',
    'plan.home.ready': 'Plan for {month} ready to review',
    'plan.home.cta': 'Review the plan',
    'promo.title': 'What you want to push',
    'promo.intro': 'Seasons, campaigns or events you want the agent to focus on. They steer the plan; they are not facts: prices and offers the agent may state come from your website.',
    'promo.name': 'What',
    'promo.details': 'Details for the agent',
    'promo.starts': 'From',
    'promo.ends': 'Until',
    'promo.add': 'Add',
    'promo.added': 'Added. The agent will use it in the next plan.',
    'promo.archive': 'Remove',
    'promo.archived': 'Removed',
    'promo.none': 'Nothing yet.',
    'promo.range': '{from} – {to}',
  },
});
